var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVideoNormal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25653",
    transform: "translate(-319.5 -138.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 11",
    cx: 28,
    cy: 28,
    r: 28,
    transform: "translate(320 139)",
    style: {
      fill: "#fff",
      stroke: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13632",
    d: "M146 16h24a3.009 3.009 0 0 1 3 3v18a3.009 3.009 0 0 1-3 3h-24a3.009 3.009 0 0 1-3-3V19a3.009 3.009 0 0 1 3-3zm8 17.18V22.82a1 1 0 0 1 1.54-.84l8.14 5.17a1 1 0 0 1 0 1.69l-8.14 5.18a1 1 0 0 1-1.54-.84z",
    transform: "translate(190 139)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13632",
    d: "M146 16h24a3.009 3.009 0 0 1 3 3v18a3.009 3.009 0 0 1-3 3h-24a3.009 3.009 0 0 1-3-3V19a3.009 3.009 0 0 1 3-3zm8 17.18V22.82a1 1 0 0 1 1.54-.84l8.14 5.17a1 1 0 0 1 0 1.69l-8.14 5.18a1 1 0 0 1-1.54-.84z",
    transform: "translate(190 139)",
    style: {
      fill: "#ff5427",
      fillRule: "evenodd"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoNormal);
export default __webpack_public_path__ + "static/media/video-normal.61114c2b1b37f1f506f6f12028907fb9.svg";
export { ForwardRef as ReactComponent };